import React from 'react';
import ResultsTable from './table/ResultsTable';


const index = (props) => (
    <ResultsTable />
);

export default index;